import React from 'react';
import PropTypes from 'prop-types';
import HelptextTooltip from 'common/components/helptext-tooltip';
import * as TooltipType from 'common/enum/tooltip-type';
import './index.scss';

/**
 * CalloutValue
 */
function CalloutValue(props) {
  const {label, value, tooltip, suffix} = props;
  const words = label.split(' '); // Split label into array
  const lastWord = words[words.length - 1]; // Capture the final word
  words.pop(); // Remove final word from array
  const newLabel = words.join(' '); // Create new label

  return (
    <div className={'CalloutValue'}>
      <div className={'CalloutValue-label'}>
        {tooltip !== '' ? (
          <React.Fragment>
            <span>{newLabel} </span>
            <span style={{whiteSpace: 'nowrap'}}>
              {lastWord}
              <HelptextTooltip tooltipType={TooltipType.narrow}>
                {tooltip}
              </HelptextTooltip>
            </span>
          </React.Fragment>
        ) : (
          label
        )}
      </div>
      {suffix !== '' ? (
        <div className={'CalloutValue-value'}>
          {value}
          <span className={'CalloutValue-suffix'}> {suffix}</span>
        </div>
      ) : (
        <div className={'CalloutValue-value'}>{value}</div>
      )}
    </div>
  );
}

CalloutValue.propTypes = {
  label: PropTypes.string,
  suffix: PropTypes.string,
  tooltip: PropTypes.string,
  value: PropTypes.any,
};
CalloutValue.defaultProps = {
  label: '',
  suffix: '',
  tooltip: '',
  value: '',
};

export default CalloutValue;
